import { lazy } from 'react';

// Lazy load components
const App = lazy(() => import('./App'));
const LoginUser = lazy(() => import('./pages/LoginUser'));
const Register = lazy(() => import('./pages/Register'));
const ForgotPassword = lazy(() => import('./pages/ForgotPassword'));
const Contact = lazy(() => import('./pages/Contact'));
const ListBlogPage = lazy(() => import('./pages/Blog')); // Fix: Blog exports ListBlogPage
const DetailBlogPage = lazy(() => import('./pages/DetailBlogPage'));
const DetailProduct = lazy(() => import('./pages/DetailProduct'));
const Cart = lazy(() => import('./pages/Cart'));
const Category = lazy(() => import('./pages/Category'));
const CategoryUpgraded = lazy(() => import('./pages/CategoryUpgraded')); // Comment out - file doesn't exist
const Checkout = lazy(() => import('./pages/Checkout'));
const InfoUser = lazy(() => import('./pages/InfoUser'));
const AdminIndex = lazy(() => import('./pages/admin'));
const PaymentSucces = lazy(() => import('./pages/PaymentSucces'));

export const routes = [
  { path: '/', component: App },
  { path: '/login', component: LoginUser },
  { path: '/register', component: Register },
  { path: '/forgot-password', component: ForgotPassword },
  { path: '/contact', component: Contact },
  { path: '/blog', component: ListBlogPage }, // Fix: Use correct component name
  { path: '/blog/:id', component: DetailBlogPage },
  { path: '/product/:id', component: DetailProduct }, // Add product detail route
  { path: '/cart', component: Cart }, // Add cart route
  { path: '/category', component: Category },
  // { path: '/category-upgraded', component: CategoryUpgraded }, // Comment out - file doesn't exist
  { path: '/checkout', component: Checkout },
  { path: '/info-user/*', component: InfoUser },
  { path: '/payment/success/:id', component: PaymentSucces },
  { path: '/admin/*', component: AdminIndex },
];